import { Map as map } from 'immutable';
const C = require("../constants");

function ProviderSelectReducer(state = map(), action) {
    switch (action.type) {
        case C.PROVIDER_SELECT:
            return action.data;
        default:
            return state;
    }
};

export default ProviderSelectReducer;


// WEBPACK FOOTER //
// ./src/reducers/ProviderSelectReducer.js